import apiClient from './http';
import type { PageList } from '../entities/Page';
import type { RealtimeConfig, RealtimeConfigVersion } from '../entities/RealtimeConfig';

const API_PREFIX = '/service/realtimeConfig';

export class RealtimeConfigService {
    static async listRealtimeConfigs(params: {
        pageNum: number;
        pageSize: number;
        appKey?: string;
        category?: string;
        key?: string;
        includeEncrypted?: boolean;
    }): Promise<PageList<RealtimeConfig>> {
        const response = await apiClient.post(`${API_PREFIX}/list`, {
            page: {
                pageNum: params.pageNum,
                pageSize: params.pageSize,
            },
            appKey: params.appKey,
            category: params.category,
            key: params.key,
            includeEncrypted: params.includeEncrypted,
        });
        return response.data;
    }

    static async listRealtimeConfigAppKeys(): Promise<string[]> {
        const response = await apiClient.post(`${API_PREFIX}/appKey/list`);
        return response.data ?? [];
    }

    static async listRealtimeConfigHistory(params: Pick<RealtimeConfig, 'appKey' | 'category' | 'key'>): Promise<RealtimeConfigVersion[]> {
        const response = await apiClient.post(`${API_PREFIX}/history/list`, params);
        return response.data ?? [];
    }

    static async insertRealtimeConfig(config: RealtimeConfig): Promise<RealtimeConfig> {
        const response = await apiClient.post(`${API_PREFIX}/insert`, config);
        return response.data;
    }

    static async updateRealtimeConfig(config: RealtimeConfig): Promise<RealtimeConfig> {
        const response = await apiClient.post(`${API_PREFIX}/update`, config);
        return response.data;
    }

    static async rollbackRealtimeConfig(params: Pick<RealtimeConfig, 'appKey' | 'category' | 'key' | 'version'>): Promise<RealtimeConfig> {
        const response = await apiClient.post(`${API_PREFIX}/rollback`, params);
        return response.data;
    }

    static async deleteRealtimeConfig(params: Pick<RealtimeConfig, 'appKey' | 'category' | 'key'>): Promise<void> {
        await apiClient.post(`${API_PREFIX}/delete`, params);
    }
}
